var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M455.111 71.111H56.889c-15.997 0-30.44 6.824-40.776 17.456l-.101-.11C6.106 98.695 0 112.631 0 128v256c0 15.369 6.106 29.305 16.012 39.543L111.59 320l58.884-63.791.192.209-59.077 64-95.577 103.334c10.343 10.69 24.829 17.137 40.877 17.137h398.222C486.528 440.889 512 415.417 512 384V128c0-31.417-25.472-56.889-56.889-56.889z",
    fill: "#eee"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.012 423.752c10.343 10.69 24.829 17.137 40.877 17.137h398.222C486.528 440.889 512 415.417 512 384v-63.582H111.59L16.012 423.752z",
    fill: "#007a3d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M455.111 71.111H56.889c-16.048 0-30.534 6.865-40.877 17.555l95.578 103.752H512V128c0-31.417-25.472-56.889-56.889-56.889z",
    fill: "#141414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#c4111b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.667 256l-59.077-64L16.012 88.457C6.106 98.695 0 112.631 0 128v256c0 15.369 6.106 29.305 16.012 39.543L111.59 320l59.077-64zM254.49 256.474c0-24.064 17.252-44.103 40.064-48.427a49.557 49.557 0 0 0-9.244-.882c-27.236 0-49.308 22.073-49.308 49.308s22.073 49.308 49.308 49.308c3.157 0 6.244-.313 9.244-.882-22.813-4.322-40.064-24.361-40.064-48.425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.069 286.328l21.02-15.033 20.864 15.26-7.794-24.633 20.949-15.132-25.842-.199-7.908-24.604-8.178 24.519-25.842-.085 20.793 15.36-8.062 24.547z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEh);
export default __webpack_public_path__ + "static/media/eh.1171487a8a9db70df6c4ca3b3aa67843.svg";
export { ForwardRef as ReactComponent };